export default __webpack_public_path__ + "static/1672-479fca627f6671b85dac93c6c8f82e55.gif";